// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

// ✅ NETTOYAGE LOCALSTORAGE - Supprimer toutes les données OFD
const cleanOldData = () => {
  console.log('🧹 Nettoyage des anciennes données...');
  
  // Supprimer les photos du localStorage
  const photoKeys = [
    'ofd_galerie_photos',
    'ofd_galerie_comments',
    'ofd_commenter_name'
  ];
  
  photoKeys.forEach(key => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
      console.log(`✅ Supprimé: ${key}`);
    }
  });
  
  // Supprimer IndexedDB (vidéos)
  const dbName = 'OFD_VideosDB';
  const request = indexedDB.deleteDatabase(dbName);
  request.onsuccess = () => {
    console.log(`✅ Base de données IndexedDB supprimée: ${dbName}`);
  };
  request.onerror = () => {
    console.log(`⚠️ Erreur lors de la suppression de ${dbName}`);
  };
  
  console.log('✅ Nettoyage terminé !');
};

// Exécuter le nettoyage
cleanOldData();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);